import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  signInOperation,
  signOutOperation,
  getUserOperation,
  refreshTokenOperation,
  signUpOperation,
} from './auth-operations';
import { AuthState, User } from './AuthTypes';

// Define the initial state of the authentication module
const initialState: AuthState = {
  accessToken: null,
  user: {
    name: null,
    email: null,
  },
  isLoggedIn: false,
  error: null,
};

// Create a slice for the authentication features with reducers and extra reducers
const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    // Define standard reducers here if needed
  },
  extraReducers: builder => {
    // Handle successful sign-in
    builder.addCase(
      signInOperation.fulfilled,
      (state, action: PayloadAction<{ accessToken: string }>) => {
        state.accessToken = action.payload.accessToken;
        state.isLoggedIn = true;
        state.error = null; // Сбрасываем ошибку при успешном входе
      },
    );
    builder.addCase(signInOperation.rejected, (state, action) => {
      state.error = action.payload?.message || action.error.message || null;
      state.isLoggedIn = false;
    });

    // Handle successful sign-out
    builder.addCase(signOutOperation.fulfilled, state => {
      state.accessToken = null;
      state.user = { name: null, email: null };
      state.isLoggedIn = false;
      state.error = null; // Сбрасываем ошибку при успешном выходе
    });

    builder.addCase(signOutOperation.rejected, (state, action) => {
      state.error = action.payload?.message || action.error.message || null;
    });

    // Handle successful sign-up
    builder.addCase(signUpOperation.fulfilled, state => {
      state.error = null;
    });

    builder.addCase(signUpOperation.rejected, (state, action) => {
      state.error = action.payload?.message || action.error.message || null;
    });

    // Handle fetching user details
    builder.addCase(getUserOperation.fulfilled, (state, action: PayloadAction<User>) => {
      state.user = action.payload;
      state.isLoggedIn = true;
      state.error = null; // Сбрасываем ошибку при успешном получении пользователя
    });

    builder.addCase(getUserOperation.rejected, (state, action) => {
      state.error = action.payload?.message || action.error.message || null;
      state.user = { name: null, email: null };
      state.isLoggedIn = false;
    });

    // Handle access token refresh
    builder.addCase(
      refreshTokenOperation.fulfilled,
      (state, action: PayloadAction<{ accessToken: string }>) => {
        state.accessToken = action.payload.accessToken;
        state.error = null; // Сбрасываем ошибку при успешном обновлении токена
      },
    );

    builder.addCase(refreshTokenOperation.rejected, (state, action) => {
      state.error = action.payload?.message || action.error.message || null;
      state.accessToken = null;
    });
  },
});

// Export the reducer as default export of this module
export default authSlice.reducer;
export { initialState };
